/* Editorial mobile drawer — accordion open/close motion.
   Animates the details body's height with WAAPI (interruptible, works
   everywhere), 200ms open / 160ms close on the drawer curve, slight fade.
   Reduced motion: instant toggle. Companion: navigation-drawer-editorial.liquid. */
(function () {
  var EASE = 'cubic-bezier(0.32, 0.72, 0, 1)';
  var OPEN_MS = 200;
  var CLOSE_MS = 160;

  /* The theme locks scroll by fixing <body> with a negative top. Inside a
     fixed body the sticky header stops sticking, which reads as the page
     jumping to the top behind the card on some engines (visible now that the
     drawer no longer covers the whole screen). For THIS drawer only, undo the
     fixed lock right after the theme applies it and keep an overflow-only
     lock instead — the card scrolls internally, the scrim blocks the rest.
     The undo MUST run in a microtask, not a timeout: the browser may paint
     between tasks, and one painted frame with the body fixed is a visible
     jump on every press. Microtasks drain before the next render, so the
     locked state can never reach the screen. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest
      ? e.target.closest('header-drawer > details > summary.drawer__button')
      : null;
    if (!btn) return;
    queueMicrotask(function () {
      var body = document.body;
      if (body.classList.contains('drawer--is-open') && body.style.position === 'fixed') {
        var y = -parseInt(body.style.top || '0', 10) || 0;
        body.style.position = '';
        body.style.top = '';
        body.style.width = '';
        window.scrollTo(0, y);
        body.style.overflow = 'hidden';
      }
    });
  });

  /* Page-level frost scrim: appended to <body> so backdrop-filter renders
     reliably (iOS ignores it on pseudos inside the sticky rounded header).
     body.ed-nav-open mirrors the nav drawer's menu-opening state. */
  (function () {
    var scrim = document.createElement('div');
    scrim.className = 'ed-page-scrim';
    scrim.setAttribute('aria-hidden', 'true');
    document.body.appendChild(scrim);
    var navDetails = document.querySelector('header-drawer > details');
    if (!navDetails || !('MutationObserver' in window)) return;
    var sync = function () {
      document.body.classList.toggle('ed-nav-open', navDetails.classList.contains('menu-opening'));
    };
    new MutationObserver(sync).observe(navDetails, { attributes: true, attributeFilter: ['class'] });
    sync();
  })();

  var reduceMotion = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : { matches: false };

  document.addEventListener('click', function (e) {
    var summary = e.target.closest
      ? e.target.closest('.ed-acc > summary, .ed-sub > summary')
      : null;
    if (!summary) return;
    var details = summary.parentElement;
    var body = details.querySelector(':scope > .ed-acc__body, :scope > .ed-sub__body');
    if (!body) return;
    var wasClosing = details.classList.contains('is-closing');
    var opening = !details.open || wasClosing;
    // Sample before cancel(): afterwards the element has its natural height.
    // Clear callbacks first so an old cancellation cannot clean up a new run.
    var startH = details.open ? body.getBoundingClientRect().height : 0;
    if (details._edAnim) {
      details._edAnim.onfinish = details._edAnim.oncancel = null;
      details._edAnim.cancel();
      details._edAnim = null;
    }
    details.classList.remove('is-closing');
    body.style.overflow = '';

    if (reduceMotion.matches || !body.animate || e.detail === 0) {
      // Keyboard/reduced-motion toggles do not wait for an animation.
      e.preventDefault();
      details.open = opening;
      return;
    }

    e.preventDefault();

    if (opening) {
      // OPEN (or reverse an in-flight close)
      details.classList.remove('is-closing');
      details.open = true;
      body.style.overflow = 'clip';
      var target = body.scrollHeight;
      var anim = body.animate(
        [
          { blockSize: startH + 'px', opacity: startH ? 1 : 0.35 },
          { blockSize: target + 'px', opacity: 1 }
        ],
        { duration: OPEN_MS, easing: EASE }
      );
      details._edAnim = anim;
      anim.onfinish = anim.oncancel = function () {
        details._edAnim = null;
        body.style.overflow = '';
      };
    } else {
      // CLOSE: animate shut first, commit open=false at the end
      details.classList.add('is-closing');
      body.style.overflow = 'clip';
      var fromH = startH;
      var animClose = body.animate(
        [
          { blockSize: fromH + 'px', opacity: 1 },
          { blockSize: '0px', opacity: 0.35 }
        ],
        { duration: CLOSE_MS, easing: EASE }
      );
      details._edAnim = animClose;
      animClose.onfinish = function () {
        details._edAnim = null;
        details.open = false;
        details.classList.remove('is-closing');
        body.style.overflow = '';
      };
      animClose.oncancel = function () {
        details._edAnim = null;
        body.style.overflow = '';
      };
    }
  });
})();
